import { extendTheme } from "@chakra-ui/react";

const config = { initialColorMode: "dark", useSystemColorMode: false };

const theme = extendTheme({
  config,
  styles: {
    global: {
      body: {
        bg: "bg.canvas",
        color: "text.primary",
      },
    },
  },
  colors: {
    brand: { 400: "#3b82f6", 500: "#2563eb" },
    // Raw dark values kept for reference; prefer the semantic tokens below.
    card: { bg: "#0f1525", border: "#1e2740" },
  },
  // Semantic tokens automatically resolve per color mode (light / dark).
  semanticTokens: {
    colors: {
      "bg.canvas": { default: "#f7f9fc", _dark: "#0a0e1a" },
      "bg.card": { default: "#ffffff", _dark: "#0f1525" },
      "bg.muted": { default: "#eef2f7", _dark: "#0f1525" },
      "border.card": { default: "#e2e8f0", _dark: "#1e2740" },
      "text.heading": { default: "#1a202c", _dark: "#ffffff" },
      "text.primary": { default: "#2d3748", _dark: "#e2e8f0" },
      "text.muted": { default: "#718096", _dark: "#a0aec0" },
    },
  },
});

export default theme;
